import React from 'react';
import { Flex, Heading, Text } from '@magicpatterns/cubed';
export function HeroSection() {
  return <Flex direction="column" align="center" justify="center" gap="5" py="9" className="text-center" data-id="element-36">
      <Heading size="8" data-id="element-37">Trust Center</Heading>
      <Text size="4" color="gray" className="max-w-[700px]" data-id="element-38">
        Security, compliance, and privacy at Magic Patterns — we are committed
        to protecting your data and maintaining the highest standards of
        security and transparency.
      </Text>
    </Flex>;
}